// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dataupdate_container_dataupdate__2hVpC{
  display: flex;
  flex:  5 1;
  flex-direction: column;
  align-items: flex-start;
  align-content: baseline;
  justify-content: center;
  background-color: var(--hsrcBackgroundLight);
  border-radius: 1rem;
  padding: 2rem;
}

.dataupdate_featured__uTvMq {
  width: 100%;
  display: flex;
  flex: 1 1; 
  flex-direction: row;
  justify-content: space-between;
} 

.dataupdate_container_row__ct8mg{
  display: flex;
  flex: 1 1; 

  flex-direction: column;
  align-content: center;
  align-items: flex-start;
  align-content: flex-start;
  justify-content: space-around;
}

.dataupdate_printviewDialog__N\\+sMk {
  min-width: 90vw !important;
  max-width: 90vw !important;
}

.dataupdate_confirmDialogOverlay__e803j {
  z-index: 10000; 
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResearcherDashboard/pages/DataUpdate/dataupdate.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,UAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,uBAAuB;EACvB,4CAA4C;EAC5C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,SAAO;EACP,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,SAAO;;EAEP,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB","sourcesContent":[".container_dataupdate{\r\n  display: flex;\r\n  flex:  5;\r\n  flex-direction: column;\r\n  align-items: flex-start;\r\n  align-content: baseline;\r\n  justify-content: center;\r\n  background-color: var(--hsrcBackgroundLight);\r\n  border-radius: 1rem;\r\n  padding: 2rem;\r\n}\r\n\r\n.featured {\r\n  width: 100%;\r\n  display: flex;\r\n  flex: 1; \r\n  flex-direction: row;\r\n  justify-content: space-between;\r\n} \r\n\r\n.container_row{\r\n  display: flex;\r\n  flex: 1; \r\n\r\n  flex-direction: column;\r\n  align-content: center;\r\n  align-items: flex-start;\r\n  align-content: flex-start;\r\n  justify-content: space-around;\r\n}\r\n\r\n.printviewDialog {\r\n  min-width: 90vw !important;\r\n  max-width: 90vw !important;\r\n}\r\n\r\n.confirmDialogOverlay {\r\n  z-index: 10000; \r\n  pointer-events: none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_dataupdate": `dataupdate_container_dataupdate__2hVpC`,
	"featured": `dataupdate_featured__uTvMq`,
	"container_row": `dataupdate_container_row__ct8mg`,
	"printviewDialog": `dataupdate_printviewDialog__N+sMk`,
	"confirmDialogOverlay": `dataupdate_confirmDialogOverlay__e803j`
};
export default ___CSS_LOADER_EXPORT___;
